import { UnSavedAction } from '../interface';
import { UNSAVED_CHANGE } from '../types';

export default function setUnSavedChange(unSavedChange: boolean): UnSavedAction {
  return {
    type: UNSAVED_CHANGE,
    unSavedChange,
  };
}
